import React from "react";
import { Link } from "react-scroll";
import "./navbar.css"; // Create this CSS file for styling

const Navbar = () => {
  return (
    <div className="topbar">
      <ul>
        <li>
          <Link to="videoContainer" spy={true} smooth={true} duration={800}>
            PLAY
          </Link>
        </li>
        <li>
          <Link to="narrativeTitle" spy={true} smooth={true} duration={800}>
            NARRATIVE
          </Link>
        </li>
        <li>
          <Link to="footer" spy={true} smooth={true} duration={800}>
            ABOUT
          </Link>
        </li>
      </ul>
      <style jsx>{`
        @media (max-width: 768px) {
          .topbar ul {
            padding: 2em 2em;
          }
        }
      `}</style>
    </div>
  );
};

export default Navbar;
